module.exports = __webpack_public_path__ + "img/TF.f7a6a949.png";